import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import {UserService} from "app/core/user/user.service";
import {ExtProfilesService} from "../../ext-profiles.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import { IUser } from 'app/interfaces/IUser'

@UntilDestroy()
@Component({
    selector: 'app-internal-gender',
    templateUrl: './internal-gender.component.html',
    styleUrls: ['./internal-gender.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InternalGenderComponent implements OnInit {

    cUser: IUser;
    keyname = 'internal_gender';
    @Input() curLang: string;
    @Input() displayDebug: false;

    fGroup: UntypedFormGroup = new UntypedFormGroup({
        'keyValue': new UntypedFormControl('', Validators.required),
        'preferredDescribe': new UntypedFormControl(false),
        'preferredDescribeText': new UntypedFormControl(''),
    });

    constructor(
        protected userService: UserService,
        protected extProfilesService: ExtProfilesService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.userService.user$.pipe(untilDestroyed(this)).subscribe((aUser) => {
            this.cUser = aUser;
            if (this.fGroup) {
                this.fGroup.patchValue({keyValue: aUser.extProfiles[this.keyname]}, {emitEvent: false});
            }
            this.cdr.markForCheck();
        })

        this.fGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {

            if (this.fGroup.get('preferredDescribe').value) {
                this.fGroup.get('preferredDescribeText').addValidators(Validators.required);
                this.fGroup.patchValue({keyValue: 'N'}, {emitEvent: false});
            } else {
                this.fGroup.get('preferredDescribeText').clearValidators();
                this.fGroup.get('preferredDescribeText').setValue('', {emitEvent: false});

            }

            this.fGroup.get('preferredDescribeText').updateValueAndValidity({emitEvent: false});

            if (this.fGroup.valid) {
                this.extProfilesService.updateExtProfiles(this.keyname, this.fGroup.get('keyValue').value);
                if (this.fGroup.get('preferredDescribe').value) {
                    this.extProfilesService.updateExtProfiles('internal_gender_preferred', this.fGroup.get('preferredDescribeText').value);
                } else {
                    this.extProfilesService.updateExtProfiles('internal_gender_preferred', '');
                }
            }
        })
    }

    setExt(value: string) {
        this.fGroup.patchValue({keyValue: value});
    }


}
